export enum MPv2UserLocationLocalStorageKey {
  UserLocation = 'user_location_details',
  GoogleLocation = 'google_location'
}
